import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { useLiterals } from '~/components/Literals'
import actions, { TYPES } from '../actions'
import api from '../api'

function selectState(state) {
  return state
}

function StoresPage({ position, location, match, config }) {
  const dispatch = useDispatch()
  const history = useHistory()
  const store = useSelector(selectState)
  const { getLiteral } = useLiterals()

  const getProduct = async (searchParams, gtin) => {
    let product

    if (gtin === 'todos') {
      return { gtin: 'all', name: `${getLiteral('1054')} ${getLiteral('1996').toLowerCase()}` }
    }

    const products = store.app.searchProductResults || store.app.products

    if (products) {
      product = products.find((i) => i.gtin === gtin)
    }

    if (!product) {
      product = (await api.search({ ...searchParams, gtin }))[0]
    }

    return product
  }

  const handleSearchStores = async (gtin) => {
    const searchParams = position.getParams()

    let product
    try {
      // precisa do buscar o produto
      dispatch(actions.updateApp({ productsLoading: true, storesLoading: true }))
      product = await getProduct(searchParams, gtin)

      if (!product) {
        !config.showContextViewEstablishment &&
          dispatch(actions.snack.add({ id: Date.now(), message: getLiteral('1685') }))

        dispatch(actions.updateApp({ productsLoading: false, storesLoading: false }))

        return config.showContextViewStore
          ? history.replace('/produto/todos')
          : history.replace('/')
      }

      dispatch(
        actions.updateApp({
          view: TYPES.VIEW_STORES,
          currentProduct: product,
          productsLoading: false
        })
      )
    } catch (error) {
      console.log('Error', error)
    }

    try {
      let payload = { ...searchParams, gtins: product.gtin }
      const { stores } = await api.getStores(payload)

      dispatch(actions.storesSuccess({ stores, gtin }))
    } catch (error) {
      console.warn('Error ~ StoresPage: ', error)

      dispatch(actions.storesNotFound({ gtin }))
    }
  }

  useEffect(() => {
    dispatch(actions.updateApp({ currentStore: null, view: TYPES.VIEW_STORES }))
    dispatch(actions.closeDrawerProduct())

    if (position.user?.lat && position.user?.lng) handleSearchStores(match.params.gtin)
  }, [location.key, position.fetched, position.user])

  return null
}

export default StoresPage
